import custom_fetch from "../custom_fetch";
import {BASE_URL} from "./base_url";

const send_web_token_code_by_phone = (mobile) => {
    const url = `${BASE_URL}/Accidents/SendWebTokenCodeByPhone?Phone=${encodeURIComponent(mobile)}`;
    return custom_fetch(url, {
        method: 'POST'
    }).then(data => {
        return data;
    }).catch(error => {
        throw error;
    })
}

export default send_web_token_code_by_phone;
